const backendUrl = process.env.REACT_APP_API_URL?.replace(/\/$/, '');

/**
 * Předem načte badges všech týmů z předaných zápasů do browser cache.
 * Využívá Image() objekty — browser odešle requesty paralelně (HTTP/2)
 * a uloží odpovědi do cache dřív, než se komponenty vyrendrují.
 *
 * @param {Array} matches - pole zápasů s homeTeam.id a awayTeam.id
 */
export const preloadBadges = (matches) => {
  if (!matches?.length || !backendUrl) return;

  const teamIds = new Set(
    matches.flatMap((m) => [m.homeTeam?.id, m.awayTeam?.id]).filter(Boolean)
  );

  // Udržíme reference na Image objekty, aby je GC nesmazal před dokončením requestu
  const images = [];
  teamIds.forEach((id) => {
    const img = new Image();
    img.src = `${backendUrl}/badges/${id}.png`;
    images.push(img);
  });
};
